module.exports = __webpack_public_path__ + "components/flag/static/square/no-0bb648fc88d34846546338ccbb15f63c.svg";